import React, { useState } from "react"

import { Loading, Notification } from "@/components"

import Settings from "@/pages/Admin/Plugins/RDStationPlugin/RDStationMarketingPlugin/Settings"

import useDidMount from "@/hooks/useDidMount"

import RDStationMarketingService from "@/services/RDStationMarketing"

import { RDStationMarketingPluginSettingsData } from "@/protocols/RdStationPluginProtocol"
import { RDStationMarketingPluginSkeleton } from "@/skeletons/Admin/RDStationMarketingPluginSkeleton"

const RDStationMarketingPlugin = () => {
	const [loading, setLoading] = useState<boolean>(false)
	const [plugin, setPlugin] = useState<RDStationMarketingPluginSettingsData>({} as RDStationMarketingPluginSettingsData)

	const handleCheckAuthCredentials = async () => {
		setLoading(true)
		try {
			const response = await RDStationMarketingService.checkAuthCredentials()

			setPlugin({
				...plugin,
				...response
			})
		} catch (error) {
			Notification.error({ message: "Não foi possível autenticar os dados do plugin." })
		}
		setLoading(false)
	}

	const handleUpdatePlugin = (data: Partial<RDStationMarketingPluginSettingsData>) => {
		setPlugin({
			...plugin,
			...data
		})
	}

	useDidMount(() => {
		handleCheckAuthCredentials()
	})

	return (
		<Loading loading={loading} customLoadingElement={<RDStationMarketingPluginSkeleton />}>
			<Settings
				plugin={plugin}
				onUpdate={handleUpdatePlugin}
			/>
		</Loading>
	)
}

export default RDStationMarketingPlugin
